/** TODO: [dims] clean up unused commented code */

import {
  Button,
  Table,
  TableColumnGroupType,
  TableColumnType,
  useTable,
  Icons,
  Space,
  TextField,
} from '@pankod/refine-antd'
import React from 'react'
import { CrudFilters, IResourceComponentsProps } from '@pankod/refine-core'

import { ModalTimespendDetail } from './ModalTimespendDetail'
import { secondToMinuteText } from '@resources/lms-management/program/utils'
import { TimespendList } from '../types'

type TableTimespendListProps = {
  programId?: any
  localProgramId?: number
}

export const TableTimespendList = ({
  programId,
  localProgramId,
}: IResourceComponentsProps & TableTimespendListProps) => {
  const { tableProps } = useTable<TimespendList>({
    resource: `programs/${programId}/local-programs/${localProgramId}/timespends`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!programId && !!localProgramId,
    },
    onSearch: (params: any) => {
      const filters: CrudFilters = []
      const { eligibleStatus, paymentStatus } = params || {}

      filters.push({
        field: 'eligibleStatus',
        operator: 'eq',
        value: eligibleStatus,
      })

      filters.push({
        field: 'paymentStatus',
        operator: 'eq',
        value: paymentStatus,
      })
      return filters
    },
  })

  const [detailVisible, setDetailVisible] = React.useState(false)
  const [selectedRecord, setSelectedRecord] =
    React.useState<TimespendList | null>(null)

  const columns: (
    | TableColumnType<TimespendList>
    | TableColumnGroupType<TimespendList>
  )[] = [
    {
      title: 'Nama Fasilitator',
      key: 'name',
      dataIndex: 'name',
      width: 220,
      fixed: 'left',
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      width: 150,
    },
    {
      title: 'No Telepon',
      key: 'phone',
      dataIndex: 'phone',
      width: 150,
    },
    {
      title: 'Kelas',
      key: 'kelas',
      dataIndex: ['kelas', 'name'],
      width: 150,
    },
    {
      title: 'Timespend (Asynchronous)',
      key: 'async',
      dataIndex: ['duration', 'async'],
      render: (value) => <TextField value={secondToMinuteText(value)} />,
      width: 150,
    },
    {
      title: 'Recording (Synchronous)',
      key: 'sync',
      dataIndex: ['duration', 'sync'],
      render: (value) => <TextField value={secondToMinuteText(value)} />,
      width: 150,
    },
    {
      title: 'Total Durasi',
      key: 'total',
      dataIndex: 'duration',
      render: (value) => secondToMinuteText(value?.async + value?.sync),
      width: 150,
    },
    {
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (_, record) => (
        <Space direction="vertical">
          <Button
            type="ghost"
            onClick={() => {
              setSelectedRecord(record)
              setDetailVisible(true)
            }}
            icon={<Icons.ContainerOutlined />}
            block
          >
            Detail & Pembayaran
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <>
      <Table<TimespendList>
        {...tableProps}
        columns={columns}
        scroll={{ x: 1500 }}
        rowKey={(record) => record.id + record.kelas.id}
      />

      <ModalTimespendDetail
        visible={detailVisible}
        onCancel={() => {
          setSelectedRecord(null)
          setDetailVisible(false)
        }}
        userId={selectedRecord?.id}
        kelasId={selectedRecord?.kelas.id}
        programId={programId}
        localProgramId={localProgramId}
      />
    </>
  )
}
